
// FornecedoresPage

import React, { useState, useEffect } from 'react';
import Header from '../../components/Header.js';
import { useTheme } from '../../contexts/ThemeContext.js';
import ExibirFornecedor from '../../components/ExibirFornecedor.js';
import CadastrarFornecedor from '../../components/CadastrarFornecedor.js';
import EditarFornecedor from '../../components/EditarFornecedor.js';
import ListarFornecedores from '../../components/ListarFornecedores.js';
import BotoesdeNavegacao from '../../components/BotoesdeNavegacao.js';
import BotoesDeAcao from '../../components/BotoesDeAcao.js';
import { useNavigate } from 'react-router-dom';
//import Axios from 'axios';
import api from '../../config/axiosConfig'; 

import '../../App.css';

function FornecedoresPage() {
  const { theme } = useTheme();
  const [fornecedores, setFornecedores] = useState([]);
  const [selectedFornecedor, setSelectedFornecedor] = useState(null);
  const [showCadastroFornecedor, setShowCadastroFornecedor] = useState(false);
  const [showEditaFornecedor, setShowEditaFornecedor] = useState(false);
  const [showExibeFornecedor, setShowExibeFornecedor] = useState(false);
  const [showListaFornecedores, setShowListaFornecedores] = useState(false); // Estado para controlar a exibição do componente ListarFornecedores
  // eslint-disable-next-line no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [totalPages, setTotalPages] = useState(1); // Inicialmente 1 página
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState({ codigo: '', nome: '', cnpj: '' });
  const navigate = useNavigate(); // Definindo o useNavigate


// Função para carregar os Fornecedors
const loadFornecedores = async (pageNumber = 1) => {
  console.log('Primeiro Fornecedor Carregado-01:');
  try {
    const response = await api.get(`/fornecedores/listarfornecedores/paginados?page=${pageNumber - 1}&size=10`);
    setFornecedores(response.data.content);
    
    // Calcular o número total de páginas com base na quantidade de Fornecedores e o tamanho da página
    const totalFornecedores = response.data.totalElements;
    const pageSize = 10; // Tamanho fixo da página
    const totalPages = Math.ceil(totalFornecedores / pageSize);
    
    setTotalPages(totalPages);

    if (!selectedFornecedor && response.data.content.length > 0) {
      setSelectedFornecedor(response.data.content[0]);
      setShowExibeFornecedor(true);
    }
  } catch (error) {
    console.error('Erro ao carregar Fornecedores:', error);
  }
};


// Função para exibir o Fornecedor selecionado
const handleCodigoClick = async (fornecedorCodfor) => {
  try {
    // Fechar o componente ListarFornecedores
    handleSairListarClick();

    // Buscar o Fornecedor Selecionado
    const response = await api.get(`/fornecedores/buscarfornecedor?codfor=${fornecedorCodfor}`);

    if (response.data && response.data.length > 0) {
      const fornecedor = Array.isArray(response.data) ? response.data[0] : response.data;
      setSelectedFornecedor(fornecedor);
      setShowExibeFornecedor(true);
    } else {
      window.alert('Fornecedor não encontrado.');
    }
  } catch (error) {
    console.error('Erro ao buscar Fornecedor:', error);
    window.alert('Erro ao buscar Fornecedor. Verifique o console para mais detalhes.');
  }
};
  
// Funções de navegação
// Função para buscar o primeiro Fornecedor
const fetchPrimeiroFornecedor = async () => {
  try {
    const response = await api.get('/fornecedores/primeiro');

     if (response.data && response.data.codfor) {
      console.log('Primeiro Fornecedor encontrado-02:', response.data);
      setSelectedFornecedor(response.data);
      setShowExibeFornecedor(true);
      } else {
        console.log('Nenhum fornecedor cadastrado');
        setSelectedFornecedor(response.data);
        setShowExibeFornecedor(true);
        window.alert('Nenhum fornecedor cadastrado.kkk');
      }
    } catch (error) {
      console.error('Erro ao buscar o primeiro fornecedor:', error);
      setSelectedFornecedor(null);
      setShowExibeFornecedor(false);
      //window.alert('Nenhum fornecedor cadastrado.www');
    }
  };
  
  
// Função para buscar o fornecedor anterior
const fetchFornecedorAnterior = async () => {
  if (selectedFornecedor && selectedFornecedor.id) {
    console.log('Buscando fornecedor anterior para o ID:', selectedFornecedor.id);
    try {
      const response = await api.get(`/fornecedores/anterior/${selectedFornecedor.id}`);

      if (response.data) {
        console.log('Fornecedor anterior encontrado:', response.data);
        setSelectedFornecedor(response.data);
        setShowExibeFornecedor(true);
      } else {
        console.warn('Nenhum fornecedor anterior encontrado.');
      }
    } catch (error) {
      console.error('Erro ao buscar o fornecedor anterior:', error);
    }
  } else {
    console.error('Nenhum fornecedor selecionado ou fornecedor sem ID');
  }
};

  
// Função para buscar o fornecedor posterior
const fetchFornecedorPosterior = async () => {
  if (selectedFornecedor && selectedFornecedor.id) {
      console.log('Buscando fornecedor posterior para o ID:', selectedFornecedor.id); // Log do ID do fornecedor selecionado
    try {
      const response = await api.get(`/fornecedores/proximo/${selectedFornecedor.id}`);

      if (response.data) {
        console.log('Fornecedor posterior encontrado:', response.data); // Log do fornecedor posterior encontrado
        setSelectedFornecedor(response.data);
        setShowExibeFornecedor(true);
        } else {
          console.warn('Nenhum fornecedor posterior encontrado.');
        }
      } catch (error) {
        console.error('Erro ao buscar o fornecedor posterior:', error);
      }
    } else {
      console.error('Nenhum fornecedor selecionado ou fornecedor sem ID');
    }
  };
  

// Função para buscar o último fornecedor
const fetchUltimoFornecedor = async () => {
  try {
    const response = await api.get('/fornecedores/ultimo');

    if (response.data) {
      console.log('Último Fornecedor encontrado:', response.data);
      setSelectedFornecedor(response.data);
      setShowExibeFornecedor(true);
    }
  } catch (error) {
    console.error('Erro ao buscar o último fornecedor:', error);
  }
};

// Efeito para carregar o primeiro fornecedor quando o componente for montado
  useEffect(() => {
  fetchPrimeiroFornecedor();
  }, []);


  // Função para Buscar Fornecedor pelo código
  const fetchFornecedorPorCodigo = async (codfor) => {
    console.log('Buscando fornecedor pelo Código:');
    try {
      const response = await api.get(`/fornecedores/buscarfornecedor?codfor=${codfor}`);

      if (response.data && response.data.length > 0) {
        const fornecedor = Array.isArray(response.data) ? response.data[0] : response.data;
        console.log('Fornecedor encontrado por Código:', fornecedor);
        window.alert('Fornecedor encontrado por Código:', fornecedor);
        setSelectedFornecedor(fornecedor);
        setShowExibeFornecedor(true);
      } else {
        window.alert('Fornecedor Não Encontrado, Verifique a Busca.');
        fetchPrimeiroFornecedor();
      }
    } catch (error) {
      console.error('Erro ao buscar fornecedor por Código:', error);
      window.alert('Fornecedor Não Encontrado, Verifique a Busca.');
      fetchPrimeiroFornecedor();
    }
  };


  // Função para Buscar Fornecedor pelo Nome
  const fetchFornecedorPorNome = async (nomefor) => {
    console.log('Buscando fornecedor pelo Nome:');
    try {
      const response = await api.get(`/fornecedores/buscarfornecedor?nomefor=${nomefor}`);

      if (response.data && response.data.length > 0) {
        const fornecedor = Array.isArray(response.data) ? response.data[0] : response.data;
        console.log('Fornecedor encontrado por Nome:', fornecedor);
        window.alert('Fornecedor encontrado por Nome:', fornecedor);
        setSelectedFornecedor(fornecedor);
        setShowExibeFornecedor(true);
      } else {
        window.alert('Fornecedor Não Encontrado, Verifique a Busca.');
        fetchPrimeiroFornecedor();
      }
    } catch (error) {
      console.error('Erro ao buscar fornecedor por Nome:', error);
      window.alert('Fornecedor Não Encontrado, Verifique a Busca.');
      fetchPrimeiroFornecedor();
    }
  };


  // Função para Buscar Fornecedor pelo CNPJ
  const fetchFornecedorPorCNPJ = async (cnpjcli) => {
    console.log('Buscando fornecedor pelo CNPJ:');
    try {
      const response = await api.get(`/fornecedores/buscarfornecedor?cnpjcli=${cnpjcli}`);

      if (response.data && response.data.length > 0) {
        const fornecedor = Array.isArray(response.data) ? response.data[0] : response.data;
        console.log('Fornecedor encontrado pelo CNPJ:', fornecedor);
        window.alert('Fornecedor encontrado pelo CNPJ:', fornecedor);
        setSelectedFornecedor(fornecedor);
        setShowExibeFornecedor(true);
      } else {
        window.alert('Fornecedor Não Encontrado, Verifique a Busca.');
        fetchPrimeiroFornecedor();
      }
    } catch (error) {
      console.error('Erro ao buscar fornecedor por CNPJ:', error);
      window.alert('Fornecedor Não Encontrado, Verifique a Busca.');
      fetchPrimeiroFornecedor();
    }
  };

  // Função para listar Fornecedores Cadastrados
    const handleListarClick = () => {
    setShowListaFornecedores(true); // Ao clicar no botão Listar, mostrar o componente ListarFornecedores
    setShowExibeFornecedor(false); // Esconder o componente ExibirFornecedor
  };

  // Função para sair do Listar Fornecedores
  const handleSairListarClick = () => {
    setShowListaFornecedores(false); // Ao clicar no botão Sair do ListarFornecedores, esconder o componente ListarFornecedores
    setShowExibeFornecedor(true); // Mostrar novamente o componente ExibirFornecedor
  };


  // Função para cadastrar Novo Fornecedor
  const handleNovoClick = () => {
    setSelectedFornecedor(null);
    setShowCadastroFornecedor(true);
    setShowEditaFornecedor(false);
    setShowExibeFornecedor(false);
  };

  // Função para Salvar Cadstro Novo Fornecedor
  const handleFornecedorSalvo = (fornecedorSalvo) => {
    setFornecedores([...fornecedores, fornecedorSalvo]);
    setSelectedFornecedor(fornecedorSalvo);
    setShowExibeFornecedor(true);
    setShowCadastroFornecedor(false);
    window.alert('Fornecedor Novo Salvo com Sucesso');
  };


  // Função para Editar Fornecedor Selecionado
  const handleEditClick = () => {
    setShowEditaFornecedor(true);
    setShowCadastroFornecedor(false);
    setShowExibeFornecedor(false);
  };

  // Função para Salvar Fornecedor Editado
  const handleFornecedorEditado = (fornecedorSalvo) => {
    setFornecedores([...fornecedores, fornecedorSalvo]);
    setSelectedFornecedor(fornecedorSalvo);
    setShowExibeFornecedor(true);
    setShowEditaFornecedor(false);
    window.alert('Fornecedor Editado com Sucesso');
  };

  // Função para cancelar o Cadastro do Fornecedor
  const handleCancelar = () => {
    setShowCadastroFornecedor(false);
    fetchPrimeiroFornecedor(); // Carrega o primeiro fornecedor da lista
    setShowExibeFornecedor(true);
  };

  // Função para cancelar a Edição do Fornecedor
  const handleCancelaEdit = () => {
    setShowCadastroFornecedor(false);
    setShowEditaFornecedor(false);
    setShowExibeFornecedor(true);
  };

  // Função para cancelar a Exibição do Fornecedor
  const handleCancelaExibe = () => {
    setShowCadastroFornecedor(false);
    setShowEditaFornecedor(false);
    setShowExibeFornecedor(false);
    setFornecedores(null); // Reseta o estado da venda
    navigate('/home'); // Redireciona para a página inicial
  };


    // Função para Excluir o Fornecedor
  const handleDeleteClick = async () => {
    if (selectedFornecedor) {
      const confirmation = window.confirm(`Tem certeza que deseja excluir o fornecedor ${selectedFornecedor.nomefor}?`);
      if (confirmation) {
        try {
          await api.delete(`/fornecedores/excluirfornecedor/${selectedFornecedor.id}`);

        // window.alert('Fornecedor excluído com sucesso.');
          window.alert(`Fornecedor: ${selectedFornecedor.nomefor} Excluido com Sucesso.`);
        // Carregar fornecedores novamente
        loadFornecedores(currentPage);
        // Buscar e exibir o primeiro fornecedor
        fetchPrimeiroFornecedor();
        } catch (error) {
          console.error('Erro ao excluir fornecedor:', error);
        }
      }
    } else {
      console.error('Nenhum fornecedor selecionado para excluir');
    }
  };


// Se os campos de busca estiverem sendo exibidos, limpa os campos de busca
  const handleSearchClick = () => {
    if (!isSearchVisible) {
    setSearchQuery({ codfor: '', nomefor: '', cnpjfor: '' });
  }
    setIsSearchVisible(!isSearchVisible);
  };
  

// A função handleSearchChange faz a busca apenas quando a tecla Enter é pressionada
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchQuery({ ...searchQuery, [name]: value });
  };


  
const handleSearchByCodigo = (e) => {
  if (e.key === 'Enter') {
    fetchFornecedorPorCodigo(searchQuery.codigo);
  }
};

const handleSearchByNome = (e) => {
  if (e.key === 'Enter') {
    fetchFornecedorPorNome(searchQuery.nome);
  }
};

const handleSearchByCNPJ = (e) => {
  if (e.key === 'Enter') {
    fetchFornecedorPorCNPJ(searchQuery.cnpj);
  }
};
  

  return (
    <div
      style={{
        backgroundColor: theme.background,
        color: theme.color,
        minHeight: 'calc(100vh - 20px)',
        width: '100%',
        paddingTop: '10px',
        textAlign: 'center',
      }}
    >
      <Header selectedCompany={localStorage.getItem('selectedCompany')} />

      {showCadastroFornecedor && (
        <CadastrarFornecedor
          handleFornecedorSalvo={handleFornecedorSalvo}
          handleCancelar={handleCancelar}
          fornecedor={selectedFornecedor}
        />
      )}

      {!showCadastroFornecedor && selectedFornecedor && !showEditaFornecedor && showExibeFornecedor && (
      <>
      <BotoesdeNavegacao
      fetchPrimeiro={fetchPrimeiroFornecedor}
      fetchAnterior={fetchFornecedorAnterior}
      fetchProximo={fetchFornecedorPosterior}
      fetchUltimo={fetchUltimoFornecedor}
      />
      <BotoesDeAcao
      handleNovoClick={handleNovoClick}
      handleEditClick={handleEditClick}
      handleDeleteClick={handleDeleteClick}
      handleSearchClick={handleSearchClick}
      handleListarClick={handleListarClick} // Verifique se handleListarClick está passada corretamente
      isSearchVisible={isSearchVisible}
      handleSearchChange={handleSearchChange}
      handleSearchByCodigo={handleSearchByCodigo}
      handleSearchByNome={handleSearchByNome}
      handleSearchByCNPJ={handleSearchByCNPJ}
      searchQuery={searchQuery}
      />
          
      <ExibirFornecedor fornecedor={selectedFornecedor}
        handleCancelaExibe={handleCancelaExibe}
      />
      </>
      )}

      
      {showListaFornecedores && (
        <ListarFornecedores
        onCodigoClick={handleCodigoClick} // Corrigindo para passar a função onCodigoClick
        handleSairListarClick={handleSairListarClick}
        />
      )}


      {showEditaFornecedor && (
      <EditarFornecedor
      fornecedor={selectedFornecedor}
      handleFornecedorEditado={handleFornecedorEditado}
      handleCancelaEdit={handleCancelaEdit}
      />
      )}
      
  </div>
  );
}

export default FornecedoresPage;

